import React from 'react'
import { bool } from 'prop-types'
import { useSelector } from 'react-redux'
import { selectLabels } from '../../../redux/configuration/selectors'
import ConfigConsume from '../../../redux/configuration/context'

// STYLES
import './ResourceAvailability.scss'
import SvgIcon from '../../SvgIcon/SvgIcon'
import themeVariables from '../../../styles/scss/configuration/_variables.scss'

const ResourceAvailability = ({
  vehiclesAvailable,
  accommodationsAvailable,
  isFlex,
  waitListAvailable,
  isDisabled,
  shouldDisplayNoPassengerMessage
}) => {
  const labels = useSelector(selectLabels)
  return (
    <ConfigConsume>
      {() => (
        <div
          className={`crossing-card-resource-availability ${
            isFlex ? 'flex' : ''
          }`}
        >
          <div className={`resources`}>
            <div className="detail accommodations">
              <SvgIcon
                type="vehicleSide"
                className="crossing-card-resource-icon"
                width="26"
                viewBox="0 0 18 16"
                height="24"
                fill={
                  isDisabled
                    ? themeVariables.themeDisabledIconColor
                    : themeVariables.themeIconColor
                }
              />
              <p>{labels.vehicleSpace}</p>
              <p
                className={`status ${
                  vehiclesAvailable ? 'available' : 'soldout'
                }`}
              >
                {vehiclesAvailable ? labels.available : labels.soldOut}
              </p>
            </div>

            <div className="detail accommodations">
              <SvgIcon
                type="cabin"
                className="crossing-card-resource-icon"
                width="26"
                viewBox="0 0 19 19"
                height="26"
                fill={
                  isDisabled
                    ? themeVariables.themeDisabledIconColor
                    : themeVariables.themeIconColor
                }
              />
              <p>{labels.cabin}</p>
              <p
                className={`status ${
                  accommodationsAvailable
                    ? 'available'
                    : waitListAvailable
                    ? 'waitlist'
                    : 'soldout'
                }`}
              >
                {accommodationsAvailable
                  ? labels.available
                  : waitListAvailable
                  ? labels.waitlistAvailable
                  : labels.soldOut}
              </p>
            </div>
            <div className="detail accommodations">
              <SvgIcon
                type="passengers"
                className="crossing-card-resource-icon"
                fill={
                  isDisabled
                    ? themeVariables.themeDisabledIconColor
                    : themeVariables.themeIconColor
                }
              />
              <p>{labels.passengerSpace}</p>
              <p
                className={`status ${
                  !shouldDisplayNoPassengerMessage ? 'available' : 'soldout'
                }`}
              >
                {!shouldDisplayNoPassengerMessage
                  ? labels.available
                  : labels.soldOut}
              </p>
            </div>
          </div>
        </div>
      )}
    </ConfigConsume>
  )
}

ResourceAvailability.propTypes = {
  vehiclesAvailable: bool,
  waitListAvailable: bool,
  accommodationsAvailable: bool,
  isFlex: bool,
  isDisabled: bool,
  shouldDisplayNoPassengerMessage: bool
}

export default ResourceAvailability
